import { render, staticRenderFns } from "./mode.vue?vue&type=template&id=6556bb5a&scoped=true&"
import script from "./mode.vue?vue&type=script&lang=js&"
export * from "./mode.vue?vue&type=script&lang=js&"
import style0 from "./mode.vue?vue&type=style&index=0&id=6556bb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556bb5a",
  null
  
)

export default component.exports